export default __webpack_public_path__ + "static/media/sbo-icon-active.f12f3e04.svg";